// IA-1 (backfill SEO por lotes): estado por fila + filtros, puros y testeables. Las sugerencias viven
// en el backend (fila.borrador); acá solo se derivan el estado, el filtrado y los contadores.

// Estado de una fila a partir de su borrador persistido.
export function estadoDeFila(fila) {
  const b = fila && fila.borrador;
  if (b && b.estado === 'aplicado') return 'aplicado';
  if (b && b.estado === 'generado') return 'generado';
  return 'pendiente';
}

// Filtra las filas por búsqueda (nombre/SKU), tipo (arquetipo), categoría, marca, colección, falta
// (titulo|meta|corta) y «ocultar aplicados». El conteo del encabezado se calcula sobre ESTO.
export function filtrarCandidatos(filas, filtros = {}) {
  const { q = '', tipo = '', categoria = '', marca = '', coleccion = '', falta = '', ocultarAplicados = true } = filtros;
  const ql = String(q).trim().toLowerCase();
  return (filas || []).filter((f) => {
    if (ocultarAplicados && estadoDeFila(f) === 'aplicado') return false;
    if (ql && !(`${f.name || ''}`.toLowerCase().includes(ql) || `${f.sku || ''}`.toLowerCase().includes(ql))) return false;
    if (tipo && f.arquetipo !== tipo) return false;
    if (categoria && !(f.categorias || []).includes(categoria)) return false;
    if (marca && f.marca !== marca) return false;
    if (coleccion && !(f.colecciones || []).includes(coleccion)) return false;
    if (falta) {
      const fl = f.faltas || {};
      if (!fl[falta]) return false;
    }
    return true;
  });
}

export const contarGeneradosSinAplicar = (filas) => (filas || []).filter((f) => estadoDeFila(f) === 'generado').length;

// Resumen para el encabezado compacto: «N productos · N sin SEO · N generados sin aplicar · N aplicados».
// Se calcula sobre TODAS las filas (no las filtradas): es el panorama del backfill.
export function resumenBackfill(filas) {
  let aplicados = 0; let generados = 0;
  (filas || []).forEach((f) => { const e = estadoDeFila(f); if (e === 'aplicado') aplicados += 1; else if (e === 'generado') generados += 1; });
  const total = (filas || []).length;
  return { total, sinSeo: total - aplicados - generados, generadosSinAplicar: generados, aplicados };
}

// Filtros vacíos (para «Limpiar filtros»). ocultarAplicados vuelve a su default (true).
export const FILTROS_VACIOS = { q: '', tipo: '', categoria: '', marca: '', coleccion: '', falta: '', ocultarAplicados: true };
export function hayFiltrosActivos(filtros = {}) {
  return !!(filtros.q || filtros.tipo || filtros.categoria || filtros.marca || filtros.coleccion || filtros.falta || filtros.ocultarAplicados === false);
}

// Ids seleccionados (unión de varios Sets) y cuántos de ellos NO están en las filas visibles (ocultos
// por los filtros). Para el aviso «N seleccionados (M ocultos por los filtros)».
export function unionSeleccion(...sets) {
  const u = new Set();
  sets.forEach((s) => { if (s) s.forEach((id) => u.add(id)); });
  return u;
}
export function contarOcultos(seleccion, filtradas) {
  const visibles = new Set((filtradas || []).map((f) => f.id));
  let n = 0;
  (seleccion || new Set()).forEach((id) => { if (!visibles.has(id)) n += 1; });
  return n;
}

// Opciones distintas para los selects de filtro, a partir de las filas.
export function opcionesDeFiltro(filas) {
  const set = (vals) => [...new Set((vals || []).filter(Boolean))].sort((a, b) => String(a).localeCompare(String(b)));
  return {
    tipos: set((filas || []).map((f) => f.arquetipo)),
    categorias: set((filas || []).flatMap((f) => f.categorias || [])),
    marcas: set((filas || []).map((f) => f.marca)),
    colecciones: set((filas || []).flatMap((f) => f.colecciones || [])),
  };
}
